export default "__VITE_ASSET__Bt5vG7Ip__"